import React from 'react';
import Loader from '@/components/common/Loader';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import { LazyDialog, type LazyDialogProps } from '@/modules/Dialogs';
import lazyWithRetry from '@/utils/lazyWithRetry';

const CreateCustomFieldDialogContent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "create-custom-field-dialog" */
      './CreateCustomFieldDialogContent'
    ),
);

export default function CreateCustomFieldDialog({
  onClose,
  success = false,
  ...dialogProps
}: {
  success: boolean;
} & LazyDialogProps) {
  const fallback = <Loader isCentered />;

  return (
    <React.Suspense fallback={fallback}>
      <LazyDialog classes={{ paper: 'w-full max-sm' }} {...dialogProps}>
        <CreateCustomFieldDialogContent onClose={onClose} success={success} />
      </LazyDialog>
    </React.Suspense>
  );
}
